'use strict';
import Config from '../Config';
// import { exception } from 'react-ga';

const Helper = {
  getApiBaseUrl() {
    return Config.ApiGwUrl;
  },
  getRedirectToLoginReturnAndCancelUrl() {
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.hash.toLowerCase());
    const cancelUrl = encodeURIComponent(window.location.pathname + window.location.hash.toLowerCase() + '?cancel=1');
    return {returnUrl, cancelUrl};
  },

  removeNamespace(input) {
    let newInput = input;
    let namespaceToRemove = Config.namespaceToRemove;
    for (let i = 0; i < namespaceToRemove.length; i++) {
      newInput = newInput.replace(new RegExp(namespaceToRemove[i], 'g'), '');
    }
    return newInput;
  },

  addHeaderParames(newParamesArray, existArray) {
    for (let i = 0; i < newParamesArray.length; i++) {
      existArray[newParamesArray[i].key] = newParamesArray[i].value;
    }

    return existArray;
  },

  getFunctionParamsString(argsName, argsVal, isJsonRequest) {
    const isArray = argsVal.constructor === Array;
    if (!isArray) {
      return JSON.stringify(argsVal);
    }
    if (!isJsonRequest) {
      let query = '';
      if (argsVal.length === 0) return null;
      for (let i = 0; i < argsName.length; i++) {
        query += argsVal[i];
        if (argsVal.length !== 1 && i !== argsVal.length - 1) {
          query += '/';
        }
      }
      return query;
    } else {
      let obj = {};

      for (let i = 0; i < argsName.length; i++) {
        obj[argsName[i]] = argsVal[i];
      }
      return JSON.stringify(obj);
    }
  },

  getUrlParameter(name) {
    if (location.hash != '') {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&]*)', 'i');
      var results = regex.exec(location.search + location.hash);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    } else {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)', 'i');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
  },

  /*
    getUrlVariables(str) {
      try {
        var regex = new RegExp(/\?\w+=\w+/g);
        var innerRegex = new RegExp(/\<?(\w+)/g);
        var varObj = {};
        var tmpStr, paramName, paramVal;
        var test = true;
        while (test) {
          test = regex.exec(str);
          if (test) {
            tmpStr = test[0];
            paramName = innerRegex.exec(tmpStr)[0];
            paramVal = innerRegex.exec(tmpStr)[0];
            varObj[paramName] = paramVal;
            innerRegex.exec(tmpStr);
          }
        }
        return {error: '', variables: varObj};
      } catch (e) {
        return {error: 'שגיאה בשמירת משתנים', variables:{}}
      }
    },
    */

  getUrlVariables() {
    let variables = {};
    try {
      const params = document.location.href.substring(document.location.href.lastIndexOf('?') + 1);

      JSON.parse('{"' + params.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
        if (key != '') {
          variables[key] = decodeURIComponent(value);
        }
      });
    } catch (e) {
      console.error('Error parsing URL variables:', e);
    }
    return variables;
  },

  onKeyPress(e) {
    const enterOrSpace = e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.which === 13 || e.which === 32;
    if (enterOrSpace) {
      e.preventDefault();
    }
  },

  genarateUuid4() {
    const ho = (n, p) => n.toString(16).padStart(p, 0);
    const view = new DataView(new ArrayBuffer(16));
    crypto.getRandomValues(new Uint8Array(view.buffer));
    view.setUint8(6, (view.getUint8(6) & 0xf) | 0x40);
    view.setUint8(8, (view.getUint8(8) & 0x3f) | 0x80);
    return `${ho(view.getUint32(0), 8)}-${ho(view.getUint16(4), 4)}-${ho(view.getUint16(6), 4)}-${ho(view.getUint16(8), 4)}-${ho(
      view.getUint32(10),
      8,
    )}${ho(view.getUint16(14), 4)}`; /// Compile the canonical textual form from the array data
  },

  removeItemFromParamArray(arr, paramArr, itemToRemove) {
    var index = paramArr.findIndex((p) => p === itemToRemove);
    arr.splice(index, 1);
    paramArr.splice(index, 1);
  },
  saveToCalendarCustomize(events) {
    const {saveAs} = require('file-saver');
    const ics = require('ics');

    const callback = (error, value) => {
      if (error) {
        console.log('we get error' + error);
        return;
      }
      saveAs(new File([value], 'CellcomReminder.ics', {type: 'text/calendar'}));
    };

    if (Array.isArray(events)) {
      ics.createEvents(events, callback);
    } else {
      ics.createEvent(events, callback);
    }
  },

  saveToCalendar() {
    const {saveAs} = require('file-saver');
    const ics = require('ics');

    const event = {
      start: [2018, 5, 30, 6, 30],
      duration: {days: 1},
      title: `ביקור טכנאי ${window.Config.brand_Name_HE}`,
      location: '',
      status: 'CONFIRMED',
      busyStatus: 'BUSY',
      //   url: 'http://www.bolderboulder.com/',
      // geo: { lat: 40.0095, lon: 105.2669 },
      // categories: ['10k races', 'Memorial Day Weekend', 'Boulder CO'],
      //  organizer: { name: 'Admin', email: 'Race@BolderBOULDER.com' },
      //  attendees: [
      //   { name: 'Adam Gibbons', email: 'adam@example.com', rsvp: true, partstat: 'ACCEPTED', role: 'REQ-PARTICIPANT' },
      //   { name: 'Brittany Seaton', email: 'brittany@example2.org', dir: 'https://linkedin.com/in/brittanyseaton', role: 'OPT-PARTICIPANT' }
      // ]
    };
    ics.createEvent(event, (error, value) => {
      if (error) {
        console.log('we get error' + error);
        return;
      }
      var file = new File([value], 'CellcomReminder.ics', {type: 'text/calendar'});
      saveAs(file);
    });
  },
  async saveToImage(elementToSave) {
    const html2canvas = require('html2canvas');
    const canvas = await html2canvas(document.querySelector(elementToSave));
    canvas.style.display = 'none';
    document.body.appendChild(canvas);
    const image = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
    const a = document.createElement('a');
    a.setAttribute('download', `info.png`);
    a.setAttribute('href', image);
    a.click();
    document.body.removeChild(canvas);
  },
  async toBase64(file) {
    const base64 = new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
    return base64;
  },
  getLoginTemplate(pathArg = '') {
    //let pathName = action.item?.contentLink?.url || '/';
    let pathName = window.location.pathname || '/';
    if (pathArg !== '') pathName = pathArg;
    let template = null;
    let urlSegments = pathName.split('/');
    let lastSegment = urlSegments.pop() || urlSegments.pop();
    switch (lastSegment) {
      case 'sale':
        template = 'Sale';
        break;
      case 'DebtPayment':
        template = 'DebtPayment';
        break;
      case 'UpdatePayment':
        template = 'UpdatePayment';
        break;
      case 'TvRemote':
        template = 'TvRemote';
        break;
      case 'Bill':
        template = 'Bill';
        break;
      case 'BillAddress':
        template = 'BillAddress';
        break;
      case 'CellDataUsage':
        template = 'CellDataUsage';
        break;
      case 'CellContentFiltering':
        template = 'CellContentFiltering';
        break;
      case 'CellDataAddon':
        template = 'CellDataAddon';
        break;
      case 'TVCodeRestore':
        template = 'TVCodeRestore';
        break;
      case 'TVPrimiumPack':
        template = 'TVPrimiumPack';
        break;
      case 'CellPackUpdate':
        template = 'CellPackUpdate';
        break;
      case 'DeliveryStatus':
        template = 'DeliveryStatus';
        break;
      case 'business':
        template = 'Business';
        break;
      case 'DebtPaymentBusiness':
        template = 'DebtPaymentBusiness';
        break;
      case 'UpdatePaymentBusiness':
        template = 'UpdatePaymentBusiness';
        break;
      case 'BillBusiness':
        template = 'BillBusiness';
        break;
      case 'SALE_MovingApartment':
        template = 'SALE_MovingApartment';
        break;
      case 'changepriceplan':
        template = 'CellPackUpdate';
        break; //ask Dalya
      case 'contactUpdate':
        template = 'contactUpdate';
        break;
      case 'contactupdate2':
        template = 'contactupdate2';
        break;
      case 'ComplitRegistrationEcommerce':
        template = 'ComplitRegistrationEcommerce';
        break;
      case 'simReplacement':
        template = 'simReplacement';
        break;
      default:
        template = lastSegment;
        break;
    }

    return template;
  },
  isComeFromSelfCarePage(productTypeList) {
      let isComeFromSelfCarePage = false;
      const prevPathname = sessionStorage.getItem('prevPathname')?.toLowerCase();
      if(!prevPathname || prevPathname === ''){
        return false;
      }
      const prevPathSegments = prevPathname?.split('/')?.filter(Boolean);
      let productType = "";
      if(prevPathSegments.length > 0){
        productType = prevPathSegments[prevPathSegments.length - 1].toLowerCase();
      }
      if(productTypeList && productTypeList.length > 0){
        if(prevPathSegments.length > 0) {
          prevPathSegments.pop();
        }
        for (let i = 0; i < productTypeList.length; i++) {
          const productTypeParam = productTypeList[i].toLowerCase();
          if ( productType.includes(productTypeParam) && Config.lobbyUrl.toLowerCase().includes(prevPathSegments.join('/'))) {
            isComeFromSelfCarePage = true;
            break;
          }
        }
      }
      else{
        const pathSegments = Config.lobbyUrl.toLowerCase().split('/').filter(Boolean);
        pathSegments.pop();
        if (prevPathname?.includes(pathSegments.join('/'))) {
          isComeFromSelfCarePage = true;
        }
      }
      return isComeFromSelfCarePage;
  }
};

export default Helper;
